export const SHOW_RACCOLTA_MODAL = "showRaccoltaModal"
export const HIDE_RACCOLTA_MODAL = "hide_raccolta_modal"

export function showRaccoltaModal(type, header, f, obj){
  return {
      type: SHOW_RACCOLTA_MODAL,
      payload:{
        type: type,
        header: header,
        function: f,
        obj: obj
    }
  }
}

export function hideRaccoltaModal(){
  return {
      type: HIDE_RACCOLTA_MODAL
  }
}